export const countConversationClosed = {
  analysisType: 'count',
  eventCollection: 'conversation.closed',
  key: 'countConversationClosed',
}
